export const OWNER = 'OWNER';
export const TEAM = 'TEAM';
export const USER = 'USER';